<script>
export default {
  name: 'TriggerListsTabs',
  data() {
    return {
      activeTab: undefined,
      tabs: [
        { name: 'Info', route: 'TriggerLists' },
        { name: 'Overdue Without Reminders', route: 'TriggerListsOverdueReminders' },
        { name: 'Last Reminder', route: 'TriggerListsLastReminder' },
      ],
    };
  },
};
</script>

<template>
  <v-tabs v-model="activeTab" mandatory>
    <v-tab
      v-for="tab in tabs"
      v-bind="tab"
      :key="tab.route"
      :to="{ name: tab.route }"
      exact
    >
      {{ tab.name }}
    </v-tab>
  </v-tabs>
</template>



// WEBPACK FOOTER //
// src/components/Triggers/TriggerListsTabs.vue